
import { defineComponent, defineAsyncComponent } from 'vue';
import CookieConsent from '@/components/layout/CookieConsent.vue';
import RefinancaBanner from '@/components/layout/RefinancaBanner.vue';
import OfficialCommunicationPopup from '@/components/shared/OfficialCommunicationPopup.vue';

export default defineComponent({
  name: 'Home',
  components: {
    Dashboard: defineAsyncComponent(
      () => import('@/components/mains/Dashboard.vue')
    ),
    FinancialTips: defineAsyncComponent(
      () => import('@/components/home/FinancialTips.vue')
    ),
    CookieConsent,
    RefinancaBanner,
    OfficialCommunicationPopup,
  },
  data() {
    return {
      isCookieVisible: true,
    };
  },
  computed: {
    currentMain() {
      return this.$store.state.currentHome;
    },
  },
  methods: {
    onCookieStatusChange(isActive: boolean) {
      this.isCookieVisible = isActive;
    },
  },
});
